import { createFileRoute } from '@tanstack/react-router';
import { COOKIES } from '../content/legal.js';
import { LegalDocument, legalHead } from '../components/site/LegalDocument.js';

/**
 * `/cookie-policy`
 *
 * The live cookie policy. The privacy policy links here, and the footer of
 * every page does too — a 404 at this path is a 404 from the whole site.
 */
export const Route = createFileRoute('/cookie-policy')({
  head: () => legalHead(COOKIES),
  component: () => <LegalDocument doc={COOKIES} />,
});
